import React, { memo } from "react";
import useSectionListItem from "./index.hooks";
import {
  Avatar,
  Icon,
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIconTypeMap,
} from "@material-ui/core";
import cn from "classnames";
import { OverridableComponent } from "@material-ui/core/OverridableComponent";

type MerchantListItemProps = {
  active: boolean;
  section: {
    slug: string;
    label: string;
    icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  };
};

const SectionListItem = ({
  section,
  active = false,
}: MerchantListItemProps) => {
  const { styles, onClicked } = useSectionListItem(section.slug);

  return (
    <ListItem
      onClick={onClicked}
      className={cn(styles.listItem, active ? styles.active : "")}
    >
      <ListItemIcon>
        <section.icon className={styles.sectionIcon} />
      </ListItemIcon>
      <ListItemText primary={section.label} />
    </ListItem>
  );
};

export default memo(SectionListItem);
